var getHandlerClasses = function (props) { return [
    // Sizing & Shape
    'tw-size-4 tw-bg-white dark:bg-zinc-600 tw-border-2 tw-border-primary-500 tw-rounded-full tw-transition tw-duration-200',
    // Interaction
    'tw-cursor-grab tw-touch-action-none tw-block',
    // Focus Styles
    'focus:tw-outline-offset-0 focus:tw-shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:tw-shadow-[0_0_0_0.2rem_rgba(113,113,126,0.5)]',
    'focus:tw-bg-primary-500 dark:focus:tw-bg-primary-500',
    'focus:tw-outline-none focus:tw-ring-0 focus:tw-ring-offset-0 focus-visible:tw-outline-2 focus-visible:tw-ring-2 focus-visible:tw-ring-offset-2 focus-visible:tw-ring-primary-700',
    // Hover Effects
    'hover:tw-bg-primary-500 hover:tw-border dark:hover:tw-bg-primary-400',
    // Position Based on Orientation
    {
        'tw-top-[50%] tw-mt-[-0.5715rem] tw-ml-[-0.5715rem]': props.orientation == 'horizontal',
        'tw-left-[50%] tw-mb-[-0.5715rem] tw-ml-[-0.4715rem]': props.orientation == 'vertical',
    },
]; };
export default {
    root: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-relative tw-rounded',
                'tw-bg-gray-300 dark:tw-bg-zinc-500 tw-border-0',
                { 'tw-h-1': props.orientation == 'horizontal', 'tw-w-1': props.orientation == 'vertical' },
                { 'tw-opacity-60 tw-select-none tw-pointer-events-none tw-cursor-default': props.disabled },
            ],
        });
    },
    range: function (_a) {
        var props = _a.props;
        return ({
            class: [
                'tw-bg-primary-500 dark:tw-bg-primary-400',
                'tw-block tw-absolute',
                {
                    'tw-top-0 tw-left-0 tw-h-full': props.orientation == 'horizontal',
                    'tw-bottom-0 tw-left-0 tw-w-full': props.orientation == 'vertical',
                },
            ],
        });
    },
    handle: function (_a) {
        var props = _a.props;
        return ({
            class: [
                // Sizing & Shape
                'tw-size-4 tw-bg-white dark:bg-zinc-600 tw-border-2 tw-border-primary-500 tw-rounded-full tw-transition tw-duration-200',
                // Interaction
                'tw-cursor-grab tw-touch-action-none tw-block',
                // Focus Styles
                'focus:tw-outline-none focus:tw-outline-offset-0 focus:tw-shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:tw-shadow-[0_0_0_0.2rem_rgba(113,113,126,0.5)]',
                'focus:tw-bg-primary-500 dark:focus:tw-bg-primary-500',
                // Hover Effects
                'hover:tw-bg-primary-500 hover:tw-border dark:hover:tw-bg-primary-500',
                // Position (orientation based)
                {
                    'tw-top-[50%] tw-mt-[-0.5715rem] tw-ml-[-0.5715rem]': props.orientation == 'horizontal',
                    'tw-left-[50%] tw-mb-[-0.5715rem] tw-ml-[-0.4715rem]': props.orientation == 'vertical',
                },
            ],
        });
    },
    starthandler: function (_a) {
        var props = _a.props;
        return ({
            class: getHandlerClasses(props),
        });
    },
    endhandler: function (_a) {
        var props = _a.props;
        return ({
            class: getHandlerClasses(props),
        });
    },
};
